import axios from 'axios';
import { FormEvent, useState } from 'react';
import { HubSpotLink } from '../config';
import '../styles/ContactUsForm.scss';

function ContactUsForm() {
  const [messageSent, setMessageSent] = useState(false);

  const [formData, setFormData] = useState({
    fields: {
      firstname: '',
      lastname: '',
      email: '',
      company: '',
      jobtitle: '',
      phoneNumber: '',
      updates_and_offers: false,
      message: '',
    },
    errors: {
      firstname: false,
      lastname: false,
      email: false,
      company: false,
      jobtitle: false,
      message: false,
    },
  });

  const handleValidation = () => {
    let fields = formData.fields;
    let errors = {
      firstname: false,
      lastname: false,
      email: false,
      company: false,
      jobtitle: false,
      message: false,
    };
    const formIsValid =
      fields['firstname'] &&
      fields['lastname'] &&
      fields['email'] &&
      fields['company'] &&
      fields['jobtitle'] &&
      fields['message'];

    errors['firstname'] = !fields['firstname'];
    errors['lastname'] = !fields['lastname'];
    errors['email'] = !fields['email'];
    errors['company'] = !fields['company'];
    errors['jobtitle'] = !fields['jobtitle'];
    errors['message'] = !fields['message'];

    setFormData({
      ...formData,
      errors,
    });
    return formIsValid;
  };

  const handleChange = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.currentTarget;
    setFormData({
      ...formData,
      fields: {
        ...formData.fields,
        [name]:
          event.currentTarget.type === 'checkbox'
            ? (event.currentTarget as HTMLInputElement).checked
            : value,
      },
    });
  };

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (handleValidation()) {
      const fields = (
        Object.keys(formData.fields) as Array<keyof typeof formData.fields>
      ).map((key) => ({
        name: key,
        value: formData.fields[key],
      }));

      const hubspotResponse = await axios.post(HubSpotLink, {
        fields,
      });

      if (hubspotResponse.data.inlineMessage) {
        setMessageSent(true);
      }
    }
  };

  return !messageSent ? (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <label className={formData.errors.firstname ? 'required' : ''}>
          FIRST NAME {formData.errors.firstname ? ' (REQUIRED)' : ''}
          <input
            type="text"
            name="firstname"
            placeholder="First name"
            onChange={handleChange}
          />
        </label>

        <label className={formData.errors.lastname ? 'required' : ''}>
          LAST NAME {formData.errors.lastname ? ' (REQUIRED)' : ''}
          <input
            type="text"
            name="lastname"
            placeholder="Last name"
            onChange={handleChange}
          />
        </label>
      </div>

      <div>
        <label className={formData.errors.email ? 'required' : ''}>
          EMAIL {formData.errors.email ? ' (REQUIRED)' : ''}
          <input
            className="email-input"
            name="email"
            type="text"
            placeholder="your@email.com"
            onChange={handleChange}
          />
        </label>
      </div>

      <div className="row">
        <label className={formData.errors.company ? 'required' : ''}>
          COMPANY {formData.errors.company ? ' (REQUIRED)' : ''}
          <input
            type="text"
            name="company"
            placeholder="Company"
            className="add-info"
            onChange={handleChange}
          />
        </label>

        <label className={formData.errors.jobtitle ? 'required' : ''}>
          JOB TITLE {formData.errors.jobtitle ? ' (REQUIRED)' : ''}
          <input
            type="text"
            name="jobtitle"
            placeholder="Job title"
            className="add-info"
            onChange={handleChange}
          />
        </label>
      </div>
      <div>
        <label>
          PHONE NUMBER
          <input
            className="email-input"
            name="phone"
            type="number"
            onChange={handleChange}
          />
        </label>
      </div>
      <div className="text-message">
        <label className={formData.errors.message ? 'required' : ''}>
          MESSAGE {formData.errors.message ? ' (REQUIRED)' : ''}
          <textarea
            name="message"
            placeholder="Start typing here..."
            onChange={handleChange}
          />
        </label>
      </div>
      <div className="row updates-container">
        <input
          type="checkbox"
          id="updates_and_offers"
          name="updates_and_offers"
          onChange={handleChange}
        />
        <label htmlFor="updates_and_offers" className="updates-checkbox">
          I would like to be updated with details about SoftServe’s latest
          products, event announcements, and thought leadership.
        </label>
      </div>
      <button type="submit">Send message</button>
      <p className="privacy-policy">
        See our{' '}
        <a
          href="https://www.softserveinc.com/uk-ua/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>{' '}
        and{' '}
        <a
          href="https://www.softserveinc.com/uk-ua/terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
        >
          Terms and Conditions
        </a>{' '}
        to know how we use your data.
      </p>
    </form>
  ) : (
    <div className="message-sent">
      <p>We appreciate you contacting us.</p>
      <p>Our team will be contacting you soon.</p>
      <p className="wishing">Have a great day ahead!</p>
    </div>
  );
}

export default ContactUsForm;
